import { MultilevelMenuService, NgMaterialMultilevelMenuModule } from 'ng-material-multilevel-menu';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { NavigationEnd, Router, Event } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { StateService } from '../../services/state.service';
import { MatButtonModule } from '@angular/material/button';
import { ScreenType } from '../../models/enums.models';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { Component, ViewChild } from '@angular/core';
import { map, shareReplay } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-main-nav',
    templateUrl: './main-nav.component.html',
    styleUrls: ['./main-nav.component.css'],
    standalone: true,
    imports: [
        RouterModule,
        CommonModule,
        MatListModule,
        MatIconModule,
        MatButtonModule,
        MatToolbarModule,
        MatSidenavModule,
        FormsModule,
        NgMaterialMultilevelMenuModule
    ],
    providers: [MultilevelMenuService],

})
export class MainNavComponent {
    @ViewChild('sidenav') _drawer?: MatSidenav;

    isLoggedIn: boolean | undefined;
    isHandset$: Observable<boolean>;

    _screenTypes = ScreenType;

    _config = {
        paddingAtStart: false,
        classname: 'my-custom-class',
        listBackgroundColor: 'white',
        fontColor: 'rgb(8, 54, 71)',
        backgroundColor: 'white',
        selectedListFontColor: '#2b9197',
        collapseOnSelect: true,
        interfaceWithRoute: true,
        highlightOnSelect: true
    };

    private _rawAppItems = [
        {
            label: 'Home',
            link: '/home',
            icon: 'home',
            type: ScreenType.Home
        },
        {
            label: 'Your Details',
            icon: 'person',
            items: [
                {
                    label: 'Personal Data',
                    icon: 'foo',
                    link: '/form/Personal',
                    type: ScreenType.Personal
                },
                {
                    label: 'Employment',
                    icon: 'foo',
                    link: '/form/Employment',
                    type: ScreenType.Employment
                }
            ]
        },
        {
            label: 'Your Accident',
            icon: 'car_crash',
            items: [
                {
                    label: 'Your Involvement',
                    icon: 'foo',
                    link: '/form/YourAccidentYourInvolvement',
                    type: ScreenType.YourAccidentYourInvolvement
                },
                {
                    label: 'Time & Location',
                    icon: 'foo',
                    link: '/form/YourAccidentTimeLocation',
                    type: ScreenType.YourAccidentTimeLocation
                },
                {
                    label: 'Description',
                    icon: 'foo',
                    link: '/form/YourAccidentDescription',
                    type: ScreenType.YourAccidentDescription
                }
            ]
        },
        {
            label: 'Your Injuries',
            icon: 'personal_injury',
            items: [
                {
                    label: 'Injury Details',
                    icon: 'foo',
                    link: '/form/YourInjuriesDetails',
                    type: ScreenType.YourInjuriesDetails
                },
                {
                    label: 'Medical Attention',
                    icon: 'foo',
                    link: '/form/YourInjuriesMedicalAttention',
                    type: ScreenType.YourInjuriesMedicalAttention
                }
            ]
        },
        {
            label: 'Your Vehicle',
            icon: 'directions_car',
            link: '/form/YourVehicle',
            type: ScreenType.YourVehicle
        },
        {
            label: 'Involved Parties',
            icon: 'people',
            items: [
                {
                    label: 'Responsible Party',
                    icon: 'foo',
                    link: '/form/ResponsibleParty',
                    type: ScreenType.ResponsibleParty
                },
                {
                    label: 'Passengers',
                    icon: 'foo',
                    link: '/form/Passengers',
                    type: ScreenType.Passengers,
                    disabled: false
                },
                {
                    label: 'Police and Witnesses',
                    icon: 'foo',
                    link: '/form/PoliceAndWitnesses',
                    type: ScreenType.PoliceAndWitnesses,
                }
            ]
        },
        {
            label: 'Summary',
            icon: 'perm_media_outline',
            link: '/form/Summary',
            type: ScreenType.Summary
        },
        {
            label: 'Terms and Conditions',
            icon: 'assignment',
            link: '/scripting',
            type: ScreenType.TermsOfService,
            disabled: true
        },
        {
            label: 'Log Out',
            icon: 'logout',
            link: '/logout',
            type: ScreenType.LogOut
        }
    ];

    private _rawAppItemsPassengers = [
        {
            label: 'Responsible Party',
            icon: 'foo',
            link: '/form/ResponsibleParty',
            type: ScreenType.ResponsibleParty
        },
        {
            label: 'Passengers',
            icon: 'foo',
            link: '/form/Passengers',
            type: ScreenType.Passengers,
            disabled: false
        },
        {
            label: 'Police and Witnesses',
            icon: 'foo',
            link: '/form/PoliceAndWitnesses',
            type: ScreenType.PoliceAndWitnesses,
        }];
    
    constructor(
        private breakpointObserver: BreakpointObserver,
        private stateService: StateService,
        private router: Router
    ) {
        this.isHandset$ = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
            map((result) => result.matches),
            shareReplay()
        );

        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.selectedItem();
            }
        });

        this.stateService.$loginDisplay.subscribe((val) => {
            this.isLoggedIn = val;
        });

        this.stateService.$claim.subscribe((claim) => {
            if (claim?.claimReference) {
                this.updateHomeLink(claim.claimReference);
            }
        });

        this.stateService.$formIsSubmitted.subscribe((isSubmitted) => { 
            this.updateTermsOfServiceState(isSubmitted);
        });

        this.stateService.$formInvolvedAccidentSaved.subscribe((isSaved) => {
            this.updatePassengersMenuItem(isSaved);
        });
    }

    get _appItems() {
        return this.filterDisabledItems(this._rawAppItems);
    }

    private filterDisabledItems(items: any[]): any[] {
        return items
            .filter(item => !item.disabled) 
            .map(item => {
                if (item.items) {
                    item.items = this.filterDisabledItems(item.items);
                }
                return item;
            });
    }

    updateHomeLink(caseReference: string): void {
        const homeItem = this._rawAppItems.find(item => item.label === 'Home');

        if (homeItem) {
            homeItem.link = `/home/${caseReference}`;
        }
    }

    updateTermsOfServiceState(isSubmitted: boolean): void {
        const termsItem = this._rawAppItems.find(item => item.label === 'Terms and Conditions');

        if (termsItem) {
            termsItem.disabled = !isSubmitted; 
        }
    }

    updatePassengersMenuItem(isSubmitted: boolean): void {
        if (isSubmitted) {
            const involvedPartiesMenuItem = this._rawAppItems.find(item => item.label === 'Involved Parties');
            if (involvedPartiesMenuItem != undefined && involvedPartiesMenuItem.items != undefined) {
                const passengersMenuItem = involvedPartiesMenuItem.items.find(item => item.label === 'Passengers');
                if (this.stateService.claim!.numberOfPassengers === 0) {
                    if (passengersMenuItem) {
                        passengersMenuItem.disabled = true;
                    }
                } else {
                   involvedPartiesMenuItem.items = this._rawAppItemsPassengers;
                }
            }
        }
    }

    selectedItem(): void {
        setTimeout(() => {
            if (this.isScreenSmall()) {
                this._drawer?.close();
            }
        }, 250);
    }
    
    isScreenSmall(): boolean {
        return window.matchMedia(`(max-width: 959px)`).matches;
    }
}
